
import {ICertificacion} from '../interface/ICertificacion';

export class Certificacion implements ICertificacion {

  id: number;
  nombre: string;
  imagen: string;
  selected?: boolean;
  nuevaImagen?: any;
  totalProductos?: number;

  constructor(certificacion: ICertificacion) {
    this.id = certificacion.id;
    this.nombre = certificacion.nombre;
    this.imagen = certificacion.imagen;
    this.selected = certificacion.selected;
    this.nuevaImagen = certificacion.nuevaImagen;
    this.totalProductos = certificacion.totalProductos;
  }

  getFormData(): FormData {
    const formData = new FormData();
    if (this.nombre) {
      formData.append('nombre', this.nombre);
    }
    if (typeof this.nuevaImagen !== 'undefined') {
      formData.append('file_upload', this.nuevaImagen, this.nuevaImagen.name);
    }

    return formData;
  }

}



// WEBPACK FOOTER //
// /app/src/model/class/Certificacion.ts